@if ((showTotals$ | async) !== true) {
  <app-inbound-delivery-overview></app-inbound-delivery-overview>
}
@if ((showTotals$ | async) === true) {
  <app-inbound-delivery-totals></app-inbound-delivery-totals>
}
